import { render, staticRenderFns } from "./paidRetention.vue?vue&type=template&id=672bc845&scoped=true&"
import script from "./paidRetention.vue?vue&type=script&lang=js&"
export * from "./paidRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bc845",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672bc845')) {
      api.createRecord('672bc845', component.options)
    } else {
      api.reload('672bc845', component.options)
    }
    module.hot.accept("./paidRetention.vue?vue&type=template&id=672bc845&scoped=true&", function () {
      api.rerender('672bc845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/paidRetention.vue"
export default component.exports